import { __assign } from "tslib";
import { connectMediaStore, useMMSelector, useMMDispatchActions, } from './withOwnReduxStore';
import { selectors } from '../../Stream';
import { getTierDeviationsStreamId } from '../helpers';
import { fetchMoreTierDeviations } from '../actions';
import { getCurrentTierId, getCurrentMediaSource } from '../selectors';
import { getDeviationsByIds } from '../../redux/deviations/selectors';
var mapStateToProps = function (state) {
    var mediaSourceType = getCurrentMediaSource(state);
    var currentTierId = getCurrentTierId(state);
    var streamId = getTierDeviationsStreamId(mediaSourceType, currentTierId);
    return {
        deviations: getDeviationsByIds(state, selectors.getItems(state, streamId)),
        hasMore: selectors.hasMore(state, streamId),
        isInitialized: selectors.isInitialized(state, streamId),
        isFetching: selectors.isFetching(state, streamId),
    };
};
export var useCurrentTierDeviations = function () { return (__assign(__assign({}, useMMSelector(mapStateToProps)), useMMDispatchActions({
    fetchMoreTierDeviations: fetchMoreTierDeviations,
}))); };
export default connectMediaStore(mapStateToProps, {
    fetchMoreTierDeviations: fetchMoreTierDeviations,
});
//# sourceMappingURL=withCurrentTierDeviations.js.map